export const events = {
  pageview: "pageview"
};

export const actions = {
  create: "create",
  send: "send",
  set: "set"
};
